import React from "react";
import { Icon, IconProps } from "@chakra-ui/react";

interface IconExtProps extends IconProps {
  dark?: boolean;
}
export const DateIcon: React.FC<IconExtProps> = (props) => {
  return (
    <Icon w="20px" h="20px" viewBox="0 0 20 20" {...props}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.1665 1.66699C14.6267 1.66699 14.9998 2.04009 14.9998 2.50033V3.33366H15.8332C17.2139 3.33366 18.3332 4.45295 18.3332 5.83366V15.8337C18.3332 17.2144 17.2139 18.3337 15.8332 18.3337H4.1665C2.78579 18.3337 1.6665 17.2144 1.6665 15.8337V5.83366C1.6665 4.45295 2.78579 3.33366 4.1665 3.33366H4.99984V2.50033C4.99984 2.04009 5.37293 1.66699 5.83317 1.66699C6.29341 1.66699 6.6665 2.04009 6.6665 2.50033V3.33366H13.3332V2.50033C13.3332 2.04009 13.7063 1.66699 14.1665 1.66699ZM16.6665 10.0003H3.33317V15.8337C3.33317 16.2939 3.70627 16.667 4.1665 16.667H15.8332C16.2934 16.667 16.6665 16.2939 16.6665 15.8337V10.0003ZM14.1665 11.667C14.6267 11.667 14.9998 12.0401 14.9998 12.5003V14.167C14.9998 14.6272 14.6267 15.0003 14.1665 15.0003H12.4998C12.0396 15.0003 11.6665 14.6272 11.6665 14.167V12.5003C11.6665 12.0401 12.0396 11.667 12.4998 11.667H14.1665ZM4.99984 5.00033H4.1665C3.70627 5.00033 3.33317 5.37342 3.33317 5.83366V8.33366H16.6665V5.83366C16.6665 5.37342 16.2934 5.00033 15.8332 5.00033H14.9998V5.83366C14.9998 6.2939 14.6267 6.66699 14.1665 6.66699C13.7063 6.66699 13.3332 6.2939 13.3332 5.83366V5.00033H6.6665V5.83366C6.6665 6.2939 6.29341 6.66699 5.83317 6.66699C5.37293 6.66699 4.99984 6.2939 4.99984 5.83366V5.00033Z"
          fill="#5F738C"
        />
      </svg>
    </Icon>
  );
};
